/**
 * Information about parameter key and index
 */
export interface KeyIndex
{
    /**
     * Key value that is passed to parameter
     */
    key: string;

    /**
     * Index of parameter
     */
    parameterIndex: number;
}
